export const fixedFloatingTypes = {
    fixed: [
        "All Fixed Rate",
        "Typically Fixed Rate"
    ],
    floating: [
        "All floating rate",
        "Typically floating rate"
    ]
}